import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createTheme, ThemeProvider } from '@material-ui/core';
import SvgIcon from '@material-ui/core/SvgIcon';
import moods from '../moods-theme';

const theme = createTheme(moods);

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: '18px',
    '& .MuiExpansionPanelSummary': {
      '&-root': {
        minHeight: 56,
        borderBottom: `1px solid ${moods.palette.grey.A200}`,
        [theme.breakpoints.down('xs')]: {
          padding: '24px 18px',
        },
        [theme.breakpoints.up('sm')]: {
          padding: 24,
        },
        [theme.breakpoints.up('md')]: {
          padding: '24px 36px',
        },
        '& .MuiTypography': {
          '&-root': {
            margin: 'auto',
            width: '100%',
          },
          '&-h4': {
            marginBottom: 4,
            [theme.breakpoints.up('sm')]: {
              fontSize: `${moods.typography.h3.fontSize}`,
            },
          },
        },
      },
      '&-content': {
        display: 'block',
        margin: 0,
        '&.Mui-expanded': {
          margin: 0,
        },
      },
    },
    '& .MuiExpansionPanelDetails': {
      '&-root': {
        padding: 0,
      },
    },
  },
  svg: {
    width: 22,
    height: 22,
  },
}));

export function CollapsibleContent({ title, infoText, ...props }) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const chevronIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className={classes.svg} width="22" height="22" viewBox="0 0 48 48">
      <title>icon__ui--chevron-down-xbold</title>
      <polygon
        points="35.589 16.875 24 28.468 12.407 16.875 9.578 19.703 24 34.126 38.418 19.702 35.589 16.875"
        fill="currentColor"
      />
    </svg>
  );

  const handleChange = (event, isExpanded) => {
    setExpanded(!!isExpanded);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <ExpansionPanel square expanded={expanded} onChange={handleChange}>
          <ExpansionPanelSummary
            expandIcon={<SvgIcon component={() => chevronIcon} viewBox="0 0 48 48" className={classes.svg} />}
            aria-label="Expand"
            id={`${title}-header`}
            aria-controls={`${title}-content`}
          >
            <Typography variant="h4" component="h4">
              {title}
            </Typography>
            <Typography component="p">{infoText}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>{props.children}</ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    </ThemeProvider>
  );
}
